export default __webpack_public_path__ + "static/media/background.66881302.png";